import React from 'react';
import { ArrowRight } from 'lucide-react';
import { trackAddToCart } from '../../hooks/useMetaPixel';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'default' | 'lg';
  withIcon?: boolean;
  href?: string;
  trackEvent?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'default',
  withIcon = false,
  href,
  trackEvent = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-lg font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-stone-800 text-stone-50 hover:bg-stone-700 hover:shadow-lg focus:ring-stone-800',
    secondary: 'bg-stone-200 text-stone-900 hover:bg-stone-300 focus:ring-stone-400',
    outline: 'border-2 border-stone-800 text-stone-800 hover:bg-stone-50 focus:ring-stone-800'
  };
  const sizes = {
    default: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  const combinedClassName = `${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`;
  const handleClick = () => {
    if (href) {
      // Track AddToCart for Shopify links
      trackAddToCart('Cuidador Sin Caos', 9300, 'ARS');
    }
  };
  // If href is provided, render as anchor tag
  if (href) {
    return <a href={href} className={combinedClassName} target="_blank" rel="noopener noreferrer" onClick={handleClick} data-id="element-241">
        {children}
        {withIcon && <ArrowRight className="ml-2 h-5 w-5" data-id="element-242" />}
      </a>;
  }
  return <button className={combinedClassName} {...props} data-id="element-243">
      {children}
      {withIcon && <ArrowRight className="ml-2 h-5 w-5" data-id="element-244" />}
    </button>;
}